import { Component, OnInit,OnDestroy,Input} from '@angular/core';
import CONFIG from 'config';

import { Subscription } from 'rxjs/Subscription';
import { MultiColumnGridService } from 'app/shared/multi-column-grid.service';
import { BackendService } from 'app/shared/backend.service';
import { AuthService } from 'app/shared/auth.service';
import { AccountService } from 'app/shared/account.service';
import { NotificationService } from 'app/notification/notification.service';
import { SearchService } from 'app/shared/search.service';
import { OrderByService } from 'app/shared/orderby.service';
import { PaginationService } from 'app/shared/pagination.service';
import { FilterService } from 'app/shared/filter.service';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Location,DecimalPipe, CurrencyPipe } from '@angular/common';
//import { throwMatDialogContentAlreadyAttachedError } from '@angular/material';
import { AccountactivityComponent } from 'app/accountactivity/accountactivity.component';
import { AccountactivityService } from 'app/accountactivity/accountactivity.service';
import { AppService } from 'app/app.service';

@Component({
  selector: 'app-positions',
  templateUrl: './positions.component.html',
  styleUrls: ['./positions.component.scss'],
  providers: [DecimalPipe, PaginationService]
})
export class PositionsComponent extends MultiColumnGridService implements OnInit, OnDestroy {
  @Input()
  names: any;
  currentSettlementAccountSubscription: Subscription;
  currentSAccount;
  accountNo:any;
  filtersOpen: boolean = false;
  data:any;
 
  loadingStatusSubscription: Subscription;
  afterfilterd: Object[] = [];

  result: string = '';
  selectedCurrency: string = '';
  
  constructor(

      public location: Location,
      public backendService: BackendService,
      public authService: AuthService,
      //public accountService: AccountService,
      public notificationService: NotificationService,
      public formBuilder: FormBuilder,
      public searchService: SearchService,
      public orderByService: OrderByService,
      public router: Router,
      public paginationService: PaginationService,
      public filterService: FilterService,
      public numberPipe: DecimalPipe,
      public currencyPipe: CurrencyPipe,
      public accountActivityService:AccountactivityService,
      
      public _appService:AppService

  ) {
      super(location, backendService, authService, notificationService, formBuilder,
          searchService, orderByService, router, paginationService, currencyPipe, filterService);
  }
  ngOnInit() {
       this.currentPage = 'positions';
     // console.log(this.currentSAccount);
      this.apiUrl = CONFIG.positionsApiUrlBase;
      this.searchArray = ['accountNumber', 'accountCurrency', 'description', 'currentBalance'];
    //   this.accountsArray = ['accountNumber'];
    //   this.securityArray = ['earningType'];
      //this.fields = ['accountNumber', 'currency', 'marketValue', 'purchValue', 'securityIDType', 'transactionNumber', 'securityCategory', 'primaryCustomer', 'description', 'isin', 'purchasePrice', 'marketPrice', 'percentageGainOrLoss', 'quantityNominal', 'accruedInterest'];
      this.fieldNames = ['AccountNumber', 'CustomerID','Currency', 'Description', 'CurrentBalance','Product'];
      this.defaultSortOrder = 'accountNumber';
      this.serviceInit(this.formatDataForSearch);
      
      this.FilterByStatus = this.formBuilder.group({
          'accountNumber': [],
          '_currency': []
      });
      this._appService.setUserLoggedIn(true);
  }
  accountNumber(value)
  {
   // console.log(value);
    localStorage.setItem('OperatingAcc', value);
    this.authService.OperatingAcc = localStorage.getItem('OperatingAcc');
    this.router.navigate(['/dashboard/accountactivity']);
  } 
  exportDataOptions(submittedData?: Object[]) {

      let name = 'Positions';
      let heading = 'Positions CSV';
      const data = submittedData || this.originalItems;
      this.exportData(data, name, heading);

  }

  clearTextSearch() 
  {
    this.term.setValue('');
    this.audit = this.originalItems;
    //console.log(this.audit);
    this.searchFilteredItems = [];
    this.setGrid(1, this.audit.length);
  }

  ngOnDestroy() {
      if (this.currentSettlementAccountSubscription) { this.currentSettlementAccountSubscription.unsubscribe(); }
  }

SearchOpen() {
  if (this.filtersOpen == false) {
      this.filtersOpen = true;
      this.clearDateFilter();
  }
  else {
      this.filtersOpen = false;
      this.clearDateFilter();
  }
}
 
searchText() {
  this.result = this.TextSearch.controls['term'].value;
   if (this.selectedCurrency && !this.currentSAccount) {
      console.log('currency filter');
      var itemsToSearch = this.filteredByCurrency;
  } else {
      console.log('no filters');
      var itemsToSearch = this.originalItems;
  };
  // let itemsToSearch = this.filteredBySettlementAccount;
  this.searchService.findItemsFromMultiple(this.result, itemsToSearch, this.searchArray)
      .then(allFiltered => {
          if (this.result.length > 0) {
              this.audit = allFiltered;
              this.searchFilteredItems = allFiltered;
          } else {
              // this.searchFilteredItems = itemsToSearch;
              this.audit = itemsToSearch;
          }
          this.totalEntries = this.audit.length;
          this.loadingData = true;
          this.pagenlenth = false;
          // console.log(this.audit);
          // console.log(this.audit.length);
          // this.orderBy(this.currentSortOrder, this.audit.length);
          this.setGrid(1, this.audit.length, "search");
          this.entryRangeSubscription = this.paginationService.entryRange
              .subscribe(range => {
                  this.entryRange = range;
                  // console.log("range" + this.entryRange[0], this.entryRange[1]);
                  if (!this.term.value) {
                      if (this.audit.length == 0) {
                          this.audit = itemsToSearch;
                      }
                      this.audit = itemsToSearch.slice(this.entryRange[0], this.entryRange[1]);
                      this.exportItems = itemsToSearch;
                      this.totalEntries = itemsToSearch.length;
                  } else {
                      this.audit = this.searchFilteredItems.slice(this.entryRange[0], this.entryRange[1]);
                      this.exportItems = this.searchFilteredItems;
                      this.totalEntries = this.searchFilteredItems.length;
                  }
              });
      });
}



  formatDataForSearch(data) {
    //  console.log(data);
      data.map(d => {
        
      });
  }
}
